import { TENANT_NAME } from "./common";

const TENANT_API_DOMAIN = () => {
  const tenantName = localStorage.getItem('tenantName') || TENANT_NAME.TIB;
  switch (tenantName) {
    case TENANT_NAME.TBD:
      return process.env.REACT_APP_API_ROOT_TBD;
    case TENANT_NAME.REACHRIGHTADS:
      return process.env.REACT_APP_API_ROOT_REACHRIGHTADS;
    case TENANT_NAME.CONQUESTDSP:
      return process.env.REACT_APP_API_ROOT_CONQUESTDSP;
    case TENANT_NAME.TIB:
    default:
      break;
  }
  return process.env.REACT_APP_API_ROOT_TIB;
};

export const TENANT_CUSTOMER_DOMAIN = () => {
  const tenantName = localStorage.getItem('tenantName') || TENANT_NAME.TIB;
  switch (tenantName) {
    case TENANT_NAME.TBD:
      return process.env.REACT_APP_CUSTOMER_TBD;
    case TENANT_NAME.REACHRIGHTADS:
      return process.env.REACT_APP_CUSTOMER_REACHRIGHTADS;
    case TENANT_NAME.CONQUESTDSP:
      return process.env.REACT_APP_CUSTOMER_CONQUESTDSP;
    default:
      break;
  }
  return process.env.REACT_APP_CUSTOMER_TIB;
};


export default TENANT_API_DOMAIN;

export const API = {
  FILE: 'files',
};

export const CODE_MANAGEMENT_API = {
  getCode: {
    name: 'getCode',
    path: (id) => `voucher-discount/${id}`,
  },
  getCodes: {
    name: 'getCodes',
    path: '/voucher-discount/filter',
  },
  getCodeTypes: {
    name: 'getCodeTypes',
    path: '/voucher-discount/type',
  },
  createCode: {
    name: 'createCode',
    path: '/voucher-discount',
  },
  updateCode: {
    name: (id) => `update code ${id}`,
    path: (id) => `/voucher-discount/${id}`,
  },
  deleteCode: {
    name: (id) => `delete code ${id}`,
    path: (id) => `/voucher-discount/${id}`,
  },
};
